import { BasketClient } from '@frontend/basket/api';
import { Basket, UpdateBasket } from '@frontend/basket/types';
import { EntityType } from '@frontend/common';
import { Spinner } from '@frontend/components/common';
import { Form } from '@frontend/components/forms';
import { EnumSelectListV2 } from '@frontend/components/select';
import { useMemo } from 'react';

import { useBasketUpdate } from './basket-update.controller';

const ID = 'basket-update';
export const BasketUpdate = () => {
    const viewProps = useBasketUpdate();

    const enumOverwrite = useMemo(() => new Map<keyof UpdateBasket, keyof typeof EnumSelectListV2>([['status', 'basket_status']]), []);

    return (
        <div id={ID}>
            {viewProps.basket === null ? (
                <Spinner />
            ) : (
                <Form<Basket, UpdateBasket>
                    id={ID}
                    useStaticId
                    object={viewProps.basket}
                    type={EntityType.BASKET}
                    dispatch={viewProps.dispatch}
                    value={viewProps.basket}
                    show={['spot_id', 'status']}
                    onCancel={viewProps.onCancel}
                    onSubmit={(v) => BasketClient.patchBasket(viewProps.basket!.account_id, viewProps.basket!.id, v)}
                    onSubmitSuccess={viewProps.onSubmitSuccess}
                    enumOverwrite={enumOverwrite}
                />
            )}
        </div>
    );
};
